<template>
<div>
  <!-- Preloader Starts -->
  <div class="preloader">
    <div class="spinner"></div>
  </div>
  <!-- Preloader End -->

  <!-- Header Area Starts -->
  <div class="head-top">
    <div class="content">
      <div class="logo">
        <a target="_blank" href="http://www.thnet.gov.cn/" style="margin-right: 20px;"><img src="static/img/global/logo-zf.png"></a>
      </div>
      <div class="header-link">
        <a target="_blank" href="https://thzwb.thnet.gov.cn/yytx/#/">首页</a>
        <a style="color: #FFFFFF" href="javascript:" @click="loginClick">{{isLogin ? `欢迎你，${userName}` : '登录'}}</a>
        <a style="color: #FFFFFF" href="javascript:" @click="loginClick" v-if="!isLogin">注册</a>
   <!--     <a target="_blank" href="#">无障碍</a> -->
        <a target="_blank" href="https://www.gdzwfw.gov.cn/portal/help/index.html">帮助中心</a>
        <span @mouseover="wxqrshow(true)" @mouseout="wxqrshow(false)">
            <a style="color: #FFFFFF">微信公众号</a>
            <div v-show="isWxqrshow" style="text-align: right"><img src="../static/img/global/footer-thzfw.png"></div>
          </span>
      </div>
    </div>
  </div>
  <!-- Header Area End -->

  <router-view></router-view>

  <!-- Footer Area Starts -->
  <div class="footer">
    <div class="content ">
      <div class="footerTop">
        <div class="foottop-left">
          <div class="part">
            <b style="color: #000">【 联系我们 】</b>
            <div>联系电话： </div>
            <div>政务大厅服务热线：020-37690333 </div>
            <div>公安户政业务专线：020-37690245 </div>
            <div>出入境（外国人）专线：12345 </div>
          </div>
          <div class="part partmiddle">
            <b style="color: #000"> </b>
            <div>  </div>
          </div>
          <div class="part">
            <b style="color: #000">【 建议反馈 】</b>
            <div><a target="_blank" href="http://www.thnet.gov.cn/zwfw/thzw/gtc/lyxd/index.html"> 留言选登 </a> </div>
            <div><a target="_blank" href="http://tyrz.gd.gov.cn/pscp/sso/static/?client_id=gzzffwrx&client_secret=0sYDtapNbbM0&redirect_uri=http%3A%2F%2Fgz12345.gz.gov.cn%2Fgdzwfw%2FverificationReturn.do%3Fref%3D%2F&response_type=code&scope=all&service=initService"> 建议投诉</a> </div>
            <div><a target="_blank" href="http://tyrz.gd.gov.cn/pscp/sso/static/?client_id=gzzffwrx&client_secret=0sYDtapNbbM0&redirect_uri=http%3A%2F%2Fgz12345.gz.gov.cn%2Fgdzwfw%2FverificationReturn.do%3Fref%3D%2F&response_type=code&scope=all&service=initService"> 投诉查询</a> </div>
          </div>
        </div>
        <div class="foottop-right">
          <div class="part">
            <b style="color: #000">【 移动办事二维码 】</b>
            <div class="ewm">
              <ul >
                <li><img src="../static/img/global/footer-yss.png"><div>粤省事</div></li>
         <!--    <li><img src="../static/img/global/footer-yst.png"><div>粤商通</div></li>  -->   
                <li><img src="../static/img/global/footer-hhb.png"><div>穗好办</div></li>
                <li><img src="../static/img/global/footer-thzfw.png"><div>天河政府网</div></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="footerBottom">
        <div class="l-img">
          <a class="toolbar-link" target="_blank" href="https://zfwzgl.www.gov.cn/exposure/jiucuo.html?site_code=4401060050">
          <img src="../static/img/global/footer-jc.png">
         </a>
        <a class="toolbar-link" target="_blank" href="https://bszs.conac.cn/sitename?method=show&id=3600B4435AA97EB4E053012819ACCA26">
          <img src="../static/img/global/footer-dz.png">
        </a>
        </div>
        <div class="r-span">
          <span>主办：广州市天河区人民政府</span>
          <span>承办：广州市天河区政务服务和数据管理局</span>
          <span>备案序号：粤ICP备15016469号-2</span>
          <span><img src="../static/img/global/footer-gh.png">粤公网安备44010602000147号</span>
        </div>
      </div>
    </div>
  </div>
  <!-- Footer Area End -->

  <div class="zxdh-toast"  v-show="isTelToastshow">
    <img src="static/img/global/toolbar-3.png">
    <span>020-37690333</span>
  </div>
  <!--  右侧导航栏-->
  <div class="toolbar">
    <div class="toolbar-collapse collapse in" id="collapseToolbar">
      <div class="toolbar-item">
        <a class="toolbar-link" target="_blank" href="https://www.gdzwfw.gov.cn/znkf/index.html?region=440106">
          <img src="static/img/global/toolbar-1.png">
          <span>智能咨询</span>
        </a>
      </div>
      <div class="toolbar-item">
        <a class="toolbar-link" target="_blank" href="https://thzwb.thnet.gov.cn/terminal/web/terminal/static/busiPage/xiaowu/validphone.html">
          <img src="static/img/global/toolbar-2.png">
          <span>政务云窗</span>
        </a>
      </div>
      <div class="toolbar-item" @click="telToastshow(true)" @mouseout="telToastshow(false)" >
        <a class="toolbar-link">
          <img src="static/img/global/toolbar-3.png">
          <span>电话咨询</span>
        </a>
      </div>
      <div class="toolbar-item">
        <a class="toolbar-link" target="_blank" href="https://apps.gdzwfw.gov.cn/zwfwyy/index.html#/?region=440106">
          <img src="static/img/global/toolbar-4.png">
          <span>办事预约</span>
        </a>
      </div>
      <div class="toolbar-item">
        <a class="toolbar-link" target="_blank" href="https://www.gdzwfw.gov.cn/portal/v2/progress-query">
          <img src="static/img/global/toolbar-5.png">
          <span>进度查询</span>
        </a>
      </div>
      <div class="toolbar-item">
        <a class="toolbar-link" target="_blank" href="http://thzwb.thnet.gov.cn/PreGuid/index.html">
          <img src="static/img/global/toolbar-6.png">
          <span>申报指引</span>
        </a>
      </div>
      <div class="toolbar-item">
        <a class="toolbar-link" target="_blank" href="https://my.gz.gov.cn/portal-citizen/home">
          <img src="static/img/global/toolbar-7.png">
          <span>市民网页</span>
        </a>
      </div>
    </div>
    <div class="toolbar-item toolbar-top">
      <a class="toolbar-link" href="#">
        <img src="static/img/global/toolbar-top.png">
        <span>返回顶部</span>
      </a>
    </div>
  </div>

</div>
</template>

<script src="../../static/js/common.js"></script>
<script>

import axios from "axios";
import {noPassByName} from "../static/js/common";

export default {
  name: 'app',
  data () {
    return {
      isWxqrshow: false,
      isTelToastshow: false,
      isLogin: false,
      userName: "",
    }
  },
  mounted () {
    console.log("页面展示")
    var devicewidth = document.documentElement.clientWidth;//获取当前分辨率下的可是区域宽度
    var scale = devicewidth / 1920; // 分母——设计稿的尺寸
    document.body.style.zoom = scale;//放大缩小相应倍数
    console.log("页面缩放系数："+scale)
    console.log("进入页面")
    this.getUserInfo()
  },
  methods: {
    getUserInfo() {
      //https://thzwb.thnet.gov.cn/test/c/api.user.WbUser/getUser
      console.log("开始获取用户信息")
      var t = this
      axios({
        method: "GET",
        url: "/icity/c/api.user.WbUser/getUser",
      }).then(res => {
        if (res.status === 200) {
          if (res.data.state == 1) {
            t.$store.commit("setUserInfo", res.data.data);
            t.userName = res.data.data.NAME
            this.setLoginState(res.data.data.NAME)
          }
          console.log("获取到用户信息:"+res.data);
        } else {
          console.log("获取用户信息失败:" + res.data);
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    setLoginState(name) {
      this.isLogin = name!=null && name.length>0
      this.userName = this.isLogin ? noPassByName(name) : ""
      console.log("用户名："+this.userName)
    },

    loginClick() {
      console.log("点击登录")
      if (this.isLogin) {return}
      var url = "https://thzwb.thnet.gov.cn/icity/login?goto=" + encodeURIComponent("https://thzwb.thnet.gov.cn/yytx/#/")
      window.location.href = url
    },

    openNewPage(url) {
      window.open(url)
    },

    wxqrshow (val) {
      this.isWxqrshow = val
    },
    telToastshow (val) {
      this.isTelToastshow = val
    }
  }
}
</script>




// WEBPACK FOOTER //
// App.vue?d305e428